import { vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: _ctx.helper.trans('labels.password'),
    modelValue: _ctx.target !== null,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = (open) => !open && _ctx.hide())
  }, {
    default: _withCtx(() => [
      _createVNode(_component_LoaderWrapper, { ref: "loader" }, {
        default: _withCtx(() => [
          _createVNode(_component_FormInputWrapper, {
            errors: _ctx.getErrors('plainPassword')
          }, {
            default: _withCtx((parentProps) => [
              _createElementVNode("div", {
                class: _normalizeClass(["input-group", parentProps.class])
              }, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event)),
                  class: _normalizeClass([parentProps.class, "form-control"]),
                  type: "text",
                  id: "change-password-input"
                }, null, 2), [
                  [_vModelText, _ctx.password]
                ]),
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.password = _ctx.helper.generatePassword()), ["prevent"])),
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, _cache[5] || (_cache[5] = [
                  _createElementVNode("i", { class: "fa fa-rotate" }, null, -1)
                ]))
              ], 2)
            ]),
            _: 1
          }, 8, ["errors"])
        ]),
        _: 1
      }, 512)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-outline-secondary btn-sm text-capitalize-first",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
      }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-outline-primary btn-sm text-capitalize-first",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
      }, _toDisplayString(_ctx.helper.trans('button.save')), 1)
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}